import {
  Box,
  Center,
  Text
} from "@chakra-ui/react";
import LineSection from "../lineSection";
import SectionHeading from "./sectionHeading";
import Lang from "../../Lang";

function Texts({ texts }) {
  return (
    <Text
      p={{ base: 4, md: 6, xl: 6 }}
      fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7", xl: "2em" }}
    >
      <Lang text={texts} />
    </Text>
  );
}

export default function AIsmallBusinessTerms() {
  return (
    <>
      <LineSection />

      <Center>
        <Box
          w={{ base: "xl", md: "full", xl: "6xl" }}
          py={{ base: 20, md: 40 }}
          color={"white"}
        >

          <SectionHeading
            title="Terms and Conditions specific for"
            span="AI-Small Business"
          />
          <Box
            mt={{ base: 10, md: 20 }}
          >


            <Texts texts="It must be a small, social business located in Colombia. AppOX may require documents and evidence that demonstrate annual income prior to application evaluation." />

            <Texts texts="AppOX may require the use of your logo or your testimonial to encourage other companies to be part of our program." />

          </Box>
        </Box>
      </Center>
    </>
  );
}